export const SliderData = [
    {
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Warner_Music_Group_logo_%282021%29.svg/1200px-Warner_Music_Group_logo_%282021%29.svg.png'
    },
    {
        image: 'https://i0.wp.com/plus.cusica.com/wp-content/uploads/2018/05/sony-music.jpg?fit=3950%2C1510&ssl=1'
    },
    {
        image: 'https://mms.businesswire.com/media/20200722005582/es/807307/5/UMG_LineworkLogo.jpg'
    },
    {
        image: 'https://mma.prnewswire.com/media/1755007/Binance_Logo.jpg?p=facebook'
    },
]